/**
 * Enum for alert severity. Used to determine the CSS to apply to the alert.
 * If you add a new severity, make sure to add the severity to the mappings below.
 */
export enum AlertSeverityEnum {
    SUCCESS = 'success',
    WARNING = 'warn',
    ERROR = 'error',
}

/**
 * Mapping of alert severity to the alert label that should be displayed.
 */
export const AlertSeverityLabelMapping: Record<AlertSeverityEnum, string> = {
    [AlertSeverityEnum.SUCCESS]: 'Success',
    [AlertSeverityEnum.WARNING]: 'Warning',
    [AlertSeverityEnum.ERROR]: 'Error',
} as const;

/**
 * Mapping of alert severity to the CSS class that should be applied to the background of the alert card.
 */
export const AlertSeverityCardClassMapping: Record<AlertSeverityEnum, string> =
    {
        [AlertSeverityEnum.SUCCESS]: '!bg-success-50',
        [AlertSeverityEnum.WARNING]: '!bg-warn-50',
        [AlertSeverityEnum.ERROR]: '!bg-error-50',
    } as const;

/**
 * Mapping of alert severity to the CSS class that should be applied to the label and icon of the alert card.
 */
export const AlertSeverityTextClassMapping: Record<AlertSeverityEnum, string> =
    {
        [AlertSeverityEnum.SUCCESS]: '!text-success-800',
        [AlertSeverityEnum.WARNING]: '!text-warn-800',
        [AlertSeverityEnum.ERROR]: '!text-error-800',
    } as const;
